import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { useAppSelector } from 'store/hooks';
import { ProgressBar, rem, Spacer } from 'design-system';
import Text from 'design-system/Text';
import useColors from 'hooks/useColors';
import { assertUnreachable } from 'utils';
const Header = ({ status }) => {
    const colors = useColors();
    const hasPostOpenInstructions = useAppSelector((state) => state.pots.hasPostOpenInstructions);
    const hasCreatedFirstPot = useAppSelector((state) => state.pots.hasCreatedPot);
    const hasFundedPot = useAppSelector((state) => state.pots.hasFundedPot);
    const hasInitiatedDepositToPot = useAppSelector((state) => state.pots.hasInitiatedDepositToPot);
    const hasFunded = hasFundedPot || hasInitiatedDepositToPot;
    const steps = useMemo(() => {
        switch (status) {
            case 'OPENING_IN_PROGRESS':
            case 'KYC_PENDING': {
                return {
                    step: 1,
                    progress: 25,
                };
            }
            case 'ACTIVE': {
                if (hasCreatedFirstPot && hasFunded) {
                    return {
                        step: 3,
                        progress: 75,
                    };
                }
                return {
                    step: 2,
                    progress: 50,
                };
            }
            default: {
                assertUnreachable(status);
                return {
                    step: 4,
                    progress: 80,
                };
            }
        }
    }, [hasCreatedFirstPot, hasFunded, status]);
    return (<View style={styles.header}>
      <Text Text-16 Secondary>
        Good job!
      </Text>
      <Spacer h={8}/>
      <Text Text-24>You’re almost there!</Text>
      <Spacer h={16}/>
      <View style={styles.progressContainer}>
        <View style={styles.progressView}>
          <ProgressBar position={hasPostOpenInstructions ? 66.6 : steps.progress} barBackgroundColor={colors.background.brandLight} colors={[colors.elements.brand, colors.elements.brand]}/>
        </View>
        <Spacer w={16}/>
        <View style={styles.stepsContainer}>
          <Text Text-14 OnBrand>
            {hasPostOpenInstructions ? '3/3' : `${steps.step}/4`}
          </Text>
        </View>
      </View>
    </View>);
};
export default Header;
const styles = StyleSheet.create({
    header: {
        paddingBottom: rem(16),
        paddingHorizontal: rem(16),
    },
    progressContainer: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    stepsContainer: {
        width: 28,
        alignItems: 'flex-end',
    },
    progressView: {
        flex: 1,
        justifyContent: 'center',
    },
});
